/**
 * aerobis UK minimum order notice (GB only).
 * UK orders below 175 EUR (shop currency) have no shipping rate on purpose
 * (no UK VAT registration; DDP via FedEx from 175 EUR, free Express from 300 EUR).
 * Liquid renders [data-uk-min-order] only when localization.country is GB.
 * This script re-checks the country (Shopify.country) on every paint, compares
 * the cart in shop EUR (cart cents / 100 / Shopify.currency.rate, same as
 * free-ship-line.js), shows the notice and disables the checkout buttons below
 * 175 EUR (express/dynamic pay buttons stay visible on purpose). Between 175 and 300 EUR the existing free-ship bar handles the
 * "remaining" line, so this script stays silent there.
 * Persistent asset: Impact AJAX drawer/cart HTML does not run inline scripts.
 */
(function () {
  if (window.aerobisUkMinOrder) return;

  var MARK = "data-umo-disabled";
  var lastCartCents = null;
  var timers = [];

  function isGB() {
    var c = (window.Shopify && Shopify.country) || "";
    return String(c).toUpperCase() === "GB";
  }

  function rateInfo(el) {
    var cur = (window.Shopify && Shopify.currency) || {};
    var rate = parseFloat(cur.rate);
    var currency = cur.active || el.getAttribute("data-umo-currency") || "EUR";
    if (!(rate > 0)) {
      if (currency === "EUR") rate = 1;
      else return null;
    }
    if (currency !== "EUR" && rate === 1) return null;
    return { rate: rate, currency: currency };
  }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat((window.Shopify && Shopify.locale) || undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return amount + " " + currency;
    }
  }

  // Minimum: round UP to a whole unit so "from £X" always clears the 175 EUR gate.
  function threshold(eur, rate) {
    return Math.ceil(eur * rate - 1e-9);
  }

  // Free-shipping amount: same rounding as the free-ship bar (free-ship-line.js) so both read the same.
  function freeAmount(eur, rate) {
    return Math.round(eur * rate);
  }

  function belowMin(cents, minEur, rate) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) n = 0;
    return n > 0 && n / 100 / rate + 1e-9 < minEur;
  }

  // Only the regular checkout button. Express/dynamic pay buttons stay visible on purpose.
  function checkoutControls() {
    return document.querySelectorAll(
      'cart-drawer button[name="checkout"], cart-drawer input[name="checkout"], ' +
      'form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]'
    );
  }

  function setBlocked(blocked, message) {
    var nodes = checkoutControls();
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (blocked) {
        n.setAttribute(MARK, "1");
        n.disabled = true;
        n.setAttribute("aria-disabled", "true");
        if (message) n.setAttribute("title", message);
        n.classList.add("is-umo-blocked");
      } else if (n.hasAttribute(MARK)) {
        n.removeAttribute(MARK);
        n.disabled = false;
        n.removeAttribute("aria-disabled");
        n.removeAttribute("title");
        n.classList.remove("is-umo-blocked");
      }
    }
  }

  function paint(cart) {
    if (cart && cart.total_price != null) {
      var c = parseInt(cart.total_price, 10);
      if (!isNaN(c)) lastCartCents = c;
    }
    var els = document.querySelectorAll("[data-uk-min-order]");
    var blocked = false;
    var msg = "";
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var info = isGB() ? rateInfo(el) : null;
      var minEur = parseFloat(el.getAttribute("data-umo-min-eur") || "175");
      var freeEur = parseFloat(el.getAttribute("data-umo-free-eur") || "300");
      var cents = lastCartCents != null ? lastCartCents : el.getAttribute("data-umo-cart-cents");
      if (!info || !belowMin(cents, minEur, info.rate)) {
        el.textContent = "";
        el.setAttribute("hidden", "");
        continue;
      }
      var tmpl = el.getAttribute("data-umo-copy") || "";
      msg = tmpl
        .replace(/__MIN__/g, money(threshold(minEur, info.rate), info.currency))
        .replace(/__FREE__/g, money(freeAmount(freeEur, info.rate), info.currency));
      el.textContent = msg;
      el.removeAttribute("hidden");
      blocked = true;
    }
    setBlocked(blocked, msg);
  }

  function schedule(cart) {
    paint(cart);
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [
      setTimeout(function () { paint(cart); }, 0),
      setTimeout(function () { paint(cart); }, 80),
      setTimeout(function () { paint(cart); }, 1300)
    ];
  }

  function fromServer() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return fetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { schedule(cart); })
      .catch(function () { schedule(null); });
  }

  function onChange(e) {
    schedule(e && e.detail && e.detail.cart);
  }

  document.addEventListener("cart:change", onChange);
  document.addEventListener("cart:updated", onChange);
  document.addEventListener("cart:refresh", fromServer);

  // Safety net: never let a blocked UK cart submit to checkout.
  document.addEventListener("submit", function (e) {
    var sub = e.submitter;
    if (sub && sub.name === "checkout" && sub.hasAttribute(MARK)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n && n.nodeType === 1 && (
            (n.hasAttribute && (n.hasAttribute("data-uk-min-order") || n.getAttribute("name") === "checkout")) ||
            (n.querySelector && n.querySelector('[data-uk-min-order], [name="checkout"]'))
          )) {
            // New drawer/cart HTML: re-read the cart, the swapped markup carries fresh cents.
            lastCartCents = null;
            schedule(null);
            return;
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() { paint(null); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.aerobisUkMinOrder = { paint: paint, refresh: fromServer, belowMin: belowMin, threshold: threshold };
})();
